
import { DISPATCH_ID } from '../../libs/utils/Const';

export const LoginReducer = (state = { email: '', password: '', user: {} }, action) => {
    switch (action.type) {
        case DISPATCH_ID.LOGIN_SET_EMAIL:
            return Object.assign({}, state, { email: action.value });
        case DISPATCH_ID.LOGIN_SET_PASSWORD:
            return Object.assign({}, state, { password: action.value });
        case DISPATCH_ID.LOGIN_CLEAN_REDUCER:
            return Object.assign({}, state, { email: '', password: '' });
        case DISPATCH_ID.LOGIN_SET_USER:
            return Object.assign({}, state, { user: action.value});
        default:
            return state;
    }
};